"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const announcementNotificationSelectedUsers = (0, graphql_tag_1.default)`
  ${data_1.pageInfoFields}
  ${data_1.userListConnectionSchemaFields}
  query announcements_notify_selectedUsers(
    $before: Int
    $after: Int
    $first: Int
    $last: Int
    $announcementId: Int!
    $selectedUsersIdList: [Int]
  ) {
    announcement {
      notify {
        selectedUsers(
          announcementId: $announcementId
          selectedUsersIdList: $selectedUsersIdList
          first: $first
          after: $after
          before: $before
          last: $last
        ) {
          pageInfo {
            ...pageInfoFields
          }
          totalCount
          edges {
            cursor
            node {
              ...userListConnectionSchemaFields
            }
          }
        }
      }
    }
  }
`;
exports.default = announcementNotificationSelectedUsers;